import UserWarningPage from './UserWarningPage'
export default UserWarningPage
